<template>
    <a-select
            showSearch
            v-model="model"
            :placeholder="placeholder"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            @search="handleSearch"
            @change="handleChange"
            @select="onSelect"
            :notFoundContent="null"
    >
        <a-select-option v-for="option in options" :key="option.id"  :value="option.id" >{{option.title}}</a-select-option>
    </a-select>
</template>
<script>
    import { getContentOptions} from '@/api/cms';
    export default {
    name: 'ContentPicker',
    data () {
      return {
//        model:undefined,
          options:[]
      }
    },
    props: {
      formData:{
        type: Object,
        required: true
      },
        field:{
            type: String|Number,
            required: true
        },
        placeholder:{
            type: String,
            default:'请选择文件'
        }
    },
    computed:{
        model:{
            get: function () {
                return this.formData[this.field];
            },
            set: function () {
            }
        }
    },
      watch: {
      },
      created(){
      },
    methods: {
        handleSearch(value){
            let that = this;
          getContentOptions({ keywords: value }).then(res => {
                that.options = res.data
            })
       },
        handleChange(value){
            this.formData[this.field] = value;
       },
        onSelect(value,option){
//            this.formData[this.field] = value;
            console.log('picker- onSelect',value);
            this.$emit("onSelect", value);
        }
    },
  }
</script>
<style>

</style>
